import React, { useEffect, useState } from 'react';
import { Table, Space, Select } from 'antd';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import { FileExcelOutlined } from '@ant-design/icons';
import { Button } from 'components/atoms'
import * as XLSX from 'xlsx';

interface FormItemProps {
  salesList: any[] | undefined;  
  hiddenColumns: string[];  
  actPage: string;
  year: string;
  startMonth: string;  
  endMonth: string;
  months: any[] | undefined;
  onChangeDetailMonth: (start:string, end:string) => void;  
}

const SALESTable = ({salesList, hiddenColumns, months, actPage, year, startMonth, endMonth, onChangeDetailMonth}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [viewColumns, setViewColumns] = useState<any[]>([]);
  const [mergeCnt, setMergeCnt] = useState<number>(0);

  const sharedOnCell = (record) => {
    if (record.type === 'total') {
      return { colSpan: 0 };
    }
    return {};
  };

  const columns: ColumnsType<any> = [
    {
      title: '강사',
      dataIndex: 'lecturer_name',
      key: 'lecturer_name',
      width: '100px',
      align: 'center',
      ellipsis: true,
      onCell: (record) => ({
        colSpan: record.type === 'total' ? mergeCnt : 1,
      }),
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value}</label>
          ):(
            <label>{value}</label>
          )
        )
      }      
    },  
    {
      title: '기업명',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '150px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },   
    {
      title: '프로젝트명',
      dataIndex: 'title',
      key: 'title',
      width: 'auto',
      align: 'center', 
      ellipsis: true,   
      onCell: sharedOnCell,
    },
    {
      title: '강의구분',
      dataIndex: 'lecture_type1',
      key: 'lecture_type1',
      width: '130px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },        
    {
      title: '강의주제',
      dataIndex: 'lecture_subject1',
      key: 'lecture_subject1',
      width: 'auto',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },      
    {
      title: '강의날짜',
      dataIndex: 'schedule_date',
      key: 'schedule_date',
      width: '100px',
      align: 'center',    
      ellipsis: true,
      onCell: sharedOnCell,
    },  
    {
      title: '강의시간',
      dataIndex: 'time_count',
      key: 'time_count',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value}</label>
          ):(
            <label>{value}</label>
          )
        )
      }      
    }, 
    {
      title: '매출',
      dataIndex: 'lecturer_price',
      key: 'lecturer_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{(value && value > 0)? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },      
    {
      title: '5점',
      dataIndex: 'class5',
      key: 'class5',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          ):(
            <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          )
        )
      }     
    },  
    {
      title: '7점',
      dataIndex: 'class7',
      key: 'class7',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          ):(
            <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          )
        )
      }      
    },  
    {
      title: '10점',
      dataIndex: 'class10',
      key: 'class10',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          ):(
            <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          )
        )
      }      
    },  
    {
      title: 'NPS',
      dataIndex: 'nps',
      key: 'nps',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          ):(
            <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          )
        )
      }      
    },   
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
  const onExcelDownload = () => {
    const header: string[] = [];
    const datas: any[] = [];
    const merges: any[] = [];

    if ("time" === actPage.toString()) {
      header.push('강사');
      header.push('기업명');
      header.push('프로젝트이름');
      header.push('강의구분');
      header.push('강의주제');
      header.push('강의날짜');
      header.push('강의시간');
      header.push('5점');
      header.push('7점');
      header.push('10점');
      header.push('NPS');
    } else {
      header.push('강사');
      header.push('기업명');
      header.push('프로젝트이름');
      header.push('강의구분');
      header.push('강의주제');
      header.push('강의날짜');
      header.push('강의시간');
      header.push('매출');
    }

    let tot_sales = 0;
    let tot_time = 0;    
    let totalnps = 0;
    let totalclass5 = 0;
    let totalclass7 = 0;
    let totalclass10 = 0;
    let totalnpsCnt = 0;
    let totalclass5Cnt = 0;
    let totalclass7Cnt = 0;
    let totalclass10Cnt = 0;

    salesList?.forEach((item, index) => {
      if (item.type === 'info') {
        if ("time" === actPage.toString()) {
          const newItem = {
            '강사': item.lecturer_name,
            '기업명': item.company_name,
            '프로젝트이름': item.title,
            '강의구분': item.lecture_type1,
            '강의주제': item.lecture_subject1,
            '강의날짜': item.schedule_date,
            '강의시간': item.time_count,
            '5점': item.class5>0?item.class5.toFixed(2):'',
            '7점': item.class7>0?item.class7.toFixed(2):'',
            '10점': item.class10>0?item.class10.toFixed(2):'',
            'NPS': item.nps>0?item.nps.toFixed(2):'',
          }
          datas.push(newItem);
        } else {
          const newItem = {
            '강사': item.lecturer_name,
            '기업명': item.company_name,
            '프로젝트이름': item.title,
            '강의구분': item.lecture_type1,
            '강의주제': item.lecture_subject1,
            '강의날짜': item.schedule_date,
            '강의시간': item.time_count,
            '매출': item.lecturer_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          }
          datas.push(newItem);
        }
                
        tot_sales += item.lecturer_price?item.lecturer_price:0;
        tot_time += item.time_count?item.time_count:0; 
        if (item.nps > 0) {
          totalnps += item.nps;
          totalnpsCnt++;
        }
        if (item.class5 > 0) {
          totalclass5 += item.class5;
          totalclass5Cnt++;
        }
        if (item.class7 > 0) {
          totalclass7 += item.class7;
          totalclass7Cnt++;
        }
        if (item.class10 > 0) {
          totalclass10 += item.class10;
          totalclass10Cnt++;
        }                 
      } else {
        if ("time" === actPage.toString()) {
          const newItem = {
            '강사': item.lecturer_name,
            '5점': item.class5>0?item.class5.toFixed(2):'',
            '7점': item.class7>0?item.class7.toFixed(2):'',
            '10점': item.class10>0?item.class10.toFixed(2):'',
            'NPS': item.nps>0?item.nps.toFixed(2):'', 
            '강의시간': item.time_count,
          }
          datas.push(newItem);
        } else {
          const newItem = {
            '강사': item.lecturer_name,
            '강의시간': item.time_count,
            '매출': item.lecturer_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          }
          datas.push(newItem);
        }
        merges.push({s: {c:0, r:index+1}, e: {c:mergeCnt-1, r:index+1}});
      }
    });
    if ("time" === actPage.toString()) {
      const newItem = {
        '강사': '합계',
        '5점': (totalclass5Cnt>0)?(totalclass5/totalclass5Cnt).toFixed(2):'',
        '7점': (totalclass7Cnt>0)?(totalclass7/totalclass7Cnt).toFixed(2):'',
        '10점': (totalclass10Cnt>0)?(totalclass10/totalclass10Cnt).toFixed(2):'',
        'NPS': (totalnpsCnt>0)?(totalnps/totalnpsCnt).toFixed(2):'',      
        '강의시간': tot_time,
      }
      datas.push(newItem);
    } else {
      const newItem = {
        '강사': '합계',
        '강의시간': tot_time,
        '매출': tot_sales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      }
      datas.push(newItem);
    }
    merges.push({s: {c:0, r:datas.length}, e: {c:mergeCnt-1, r:datas.length}});

    const book = XLSX.utils.book_new();
    const nurses = XLSX.utils.json_to_sheet(
      datas, 
      { 
        header : header, 
        skipHeader : false 
      } 
    );

    nurses["!cols"] = [
      { wpx : 100 } 
    , { wpx : 150 } 
    , { wpx : 200 }  
    , { wpx : 150 }  
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    ]
    if (merges.length > 0) {
      nurses["!merges"]  = merges;   
    }

    XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
    XLSX.writeFile( book, year+'_'+startMonth +'월_'+endMonth+'월_강의평가.xlsx'); 
  }  

  /* ======================================================
  * hooks
  * ====================================================== */

  useEffect(() => {
    if (!!hiddenColumns) {
      const newColumns = columns.filter((item) => hiddenColumns.findIndex((col)=>col === item.key) < 0);
      setViewColumns(newColumns);

      let cnt = newColumns.length;
      if (hiddenColumns.findIndex((col)=>col === 'lecturer_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'time_count') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'class5') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'class7') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'class10') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'nps') < 0) {cnt--;}
      setMergeCnt(cnt);
    }

  }, [hiddenColumns, salesList]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space style={{width:'100%', justifyContent:'space-between', marginTop:'20px'}}>
        <Space>
          <Select 
            value={startMonth}
            options={months}
            onSelect={(value)=>{onChangeDetailMonth(value, endMonth)}}
            style={{width: '80px'}}
          /> 
          <Select 
            value={endMonth}
            options={months}
            onSelect={(value)=>{onChangeDetailMonth(startMonth, value)}}
            style={{width: '80px'}}
          />       
        </Space>
        <Space>
          <Button icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀다운로드</Button>
        </Space>            
      </Space>      
      <TableWrapper isSearch={false}>
        <Table
          tableLayout="fixed"
          dataSource={salesList}
          columns={viewColumns}
          pagination={false}
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}
          summary={pageData => {
            let totalPrice = 0;
            let totalTime = 0;
            let totalnps = 0;
            let totalclass5 = 0;
            let totalclass7 = 0;
            let totalclass10 = 0;
            let totalnpsCnt = 0;
            let totalclass5Cnt = 0;
            let totalclass7Cnt = 0;
            let totalclass10Cnt = 0;

            pageData.forEach((item) => {
              if (item.type === 'info') {
                totalPrice += item.lecturer_price;
                totalTime += item.time_count;
                if (item.nps > 0) {
                  totalnps += item.nps;
                  totalnpsCnt++;
                }
                if (item.class5 > 0) {
                  totalclass5 += item.class5;
                  totalclass5Cnt++;
                }
                if (item.class7 > 0) {
                  totalclass7 += item.class7;
                  totalclass7Cnt++;
                }
                if (item.class10 > 0) {
                  totalclass10 += item.class10;
                  totalclass10Cnt++;
                }
              }
            });

            return (
              <Table.Summary.Row style={{backgroundColor:'#f7f7f7', fontWeight:'500', color:'red'}}>
                <Table.Summary.Cell colSpan={mergeCnt} index={0} align='center'>합계</Table.Summary.Cell>
                {(hiddenColumns.findIndex((col)=>col === 'time_count') < 0) && (<Table.Summary.Cell  index={6} align='center'>{totalTime.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'lecturer_price') < 0) && (<Table.Summary.Cell  index={7} align='right'>{totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}                
                {(hiddenColumns.findIndex((col)=>col === 'class5') < 0) && (<Table.Summary.Cell  index={8} align='center'>{(totalclass5Cnt>0)?(totalclass5/totalclass5Cnt).toFixed(2):''}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'class7') < 0) && (<Table.Summary.Cell  index={9} align='center'>{(totalclass7Cnt>0)?(totalclass7/totalclass7Cnt).toFixed(2):''}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'class10') < 0) && (<Table.Summary.Cell  index={10} align='center'>{(totalclass10Cnt>0)?(totalclass10/totalclass10Cnt).toFixed(2):''}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'nps') < 0) && (<Table.Summary.Cell  index={11} align='center'>{(totalnpsCnt>0)?(totalnps/totalnpsCnt).toFixed(2):''}</Table.Summary.Cell>)}
              </Table.Summary.Row>
            );
          }}
        />
      </TableWrapper>  
    </Space>
  );
};

export default SALESTable;
